(function () {
  async function initCounter(el) {
    if (el.dataset.pvcInitialized === "true") return;
    el.dataset.pvcInitialized = "true";

    const endpoint = el.dataset.endpoint;
    const productId = el.dataset.productId;
    const shop = el.dataset.shop;
    const days = el.dataset.days || "1";
    const mode = el.dataset.mode || "total";
    const threshold = Number(el.dataset.threshold || 0);
    const popularThreshold = Number(el.dataset.popularThreshold || 15);
    const countNode = el.querySelector(".product-view-counter__count");
    const labelNode = el.querySelector(".product-view-counter__label");
    const subtextNode = el.querySelector(".product-view-counter__subtext");
    const iconDefault = el.querySelector(".icon-default");
    const iconPopular = el.querySelector(".icon-popular");

    if (!endpoint || !productId || !shop) return;

    try {
      const res = await fetch(`${endpoint}/track-and-count`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          shop,
          product_id: productId,
          days,
          mode
        }),
        credentials: "omit",
        keepalive: true
      });

      if (!res.ok) throw new Error("Track/count request failed");

      const data = await res.json();
      const count = Number(data.count || 0);

      if (count < threshold) {
        el.classList.add("is-hidden");
        return;
      }

	  if (countNode) {
		const displayCount =
		count >= popularThreshold
		? `${popularThreshold.toLocaleString()}+`
		: count.toLocaleString();

		countNode.textContent = displayCount;
		}

      if (labelNode) {
        labelNode.textContent =
          mode === "unique"
            ? `unique views in the last ${days} days`
            : `views in the last ${days} days`;
      }

      if (count >= popularThreshold) {
        el.classList.add("is-popular");
        if (subtextNode) subtextNode.textContent = "Popular now";
        if (iconDefault) iconDefault.style.display = "none";
        if (iconPopular) iconPopular.style.display = "block";
      } else {
        if (subtextNode) subtextNode.textContent = "Updated live";
        if (iconDefault) iconDefault.style.display = "block";
        if (iconPopular) iconPopular.style.display = "none";
      }
    } catch (e) {
      el.classList.add("is-hidden");
    }
  }

  function boot() {
    document.querySelectorAll(".product-view-counter").forEach(initCounter);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", boot);
})();